import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrame } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrame(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_tree(b: boolean) {
  LwAPI?.applyConfig({ treeExpanded: b });
}

function ex_hidenavbarpmi(b: boolean) {
  LwAPI?.applyConfig({ navbarEntries: { pmi: b } });
}

// Bind functions to buttons
document.getElementById("hidetree")?.addEventListener("click", async () => {
  await apiReady;
  ex_tree(false);
});
document.getElementById("showtree")?.addEventListener("click", async () => {
  await apiReady;
  ex_tree(true);
});
document.getElementById("hidepmi")?.addEventListener("click", async () => {
  await apiReady;
  ex_hidenavbarpmi(false);
});
document.getElementById("showpmi")?.addEventListener("click", async () => {
  await apiReady;
  ex_hidenavbarpmi(true);
});
